import * as t from "io-ts";
import { MoneyTotal } from "./MoneyTotal";

export const LeadJobSummary = t.intersection([
  t.type({
    id: t.string,
    archived: t.string,
    status: t.string,
    finance_status: t.string,
    quoted_to: t.string,
    total: MoneyTotal,
  }),
  t.partial({
    cid: t.string,
    aid: t.string,
    oid: t.string,
    eid: t.string,
    rid: t.string,
    bid: t.string,
    tid: t.string,
  }),
]);

export interface LeadJobSummary {
  id: string;
  cid?: string;
  aid?: string;
  oid?: string;
  eid?: string;
  rid?: string;
  bid?: string;
  tid?: string;
  archived: string;
  status: string;
  finance_status: string;
  quoted_to: string;
  total: MoneyTotal;
}
